var map = {
	"./screen1.jpg": 26,
	"./screen2.jpg": 27,
	"./screen3.jpg": 28,
	"./screen4.jpg": 29,
	"./screen5.jpg": 30,
	"./screen6.jpg": 31,
	"./screen7.jpg": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;